import { render } from "./NetworkError.vue?vue&type=template&id=5b587617"
import script from "./NetworkError.vue?vue&type=script&lang=js"
export * from "./NetworkError.vue?vue&type=script&lang=js"
script.render = render

export default script